if ( typeof ModalBox !== 'function' ) {

	class ModalBox extends HTMLElement {

		constructor() {

			window.inertElems = document.querySelectorAll('[data-js-inert]');

			super();
			this.o = {
				...{
					show: 10, 
					frequency: 'day', 
					enabled: true,
					showOnce: true,
					closeByKey: true,
					disableScroll: true,
					enableClose: false,
					type: false,
					blockTabNavigation: false,
					openedModalBodyClass: 'modal-opened',
				}, ...JSON.parse(this.dataset.options)
			};

			if ( this.o.type == "exit_intent_popup") {

				this.o.enabled = false;

				const showBanner = () => {
					this.o.enabled = true;
					
					this._modalKey = `modal-${document.location.hostname}-${this.id}`;
					this._modalStorage = ! localStorage.getItem(this._modalKey) ? 'empty' : JSON.parse(localStorage.getItem(this._modalKey));
					if ( this.querySelector('[data-content]') ) {
						this._modalText = this.querySelector('[data-content]').textContent;
					}

					const timeNow = new Date().getTime();
					const inBetween = Math.round((timeNow - this._modalStorage['shown']) / 1000);

					let showModal = false;

					if ( this._modalStorage == 'empty'
						|| ( this.o.frequency == 'day' && inBetween > 86400 )
						|| ( this.o.frequency == 'week' && inBetween > 604800 )
						|| ( this.o.frequency == 'month' && inBetween > 2419200 )
						|| this._modalStorage['content'] != this._modalText
					) {
						showModal = true
					}

					if ( showModal ) {
						setTimeout(()=>{
							this.show();
						}, 0);
						setTimeout(()=>{
							this.querySelectorAll('[data-js-close]').forEach(elm=>elm.addEventListener('click',()=>{this.hide(this.o.showOnce)}));
						}, 100);
					}
				}

				let lastMouseY = 0; 
				let topOffset = 20; 

				document.addEventListener('mousemove', function(event) {
					const currentMouseY = event.clientY;
					if (currentMouseY < lastMouseY && currentMouseY < topOffset && ! Shopify.designMode) { 
						showBanner();
					}
					lastMouseY = currentMouseY;
				});
				
			}

			if ( this.o.type == "cookies") {
				this.o.enabled = false;
				this._cookieBannerShown = false;
				this._cookieBannerTrigger = 'immediate';
				this._cookieDelayTimer = null;
				this._cookieScrollHandler = null;
				const cookieExperiment = window.__x4CookieTriggerExperiment || {};

				const publishCookieEvent = (eventName, payload = {}) => {
					const basePayload = {
						page_path: document.location.pathname,
						timestamp: new Date().toISOString(),
						experiment_id: cookieExperiment.experiment_id || null,
						variant_id: cookieExperiment.variant_id || 'control'
					};
					const eventPayload = Object.assign(basePayload, payload);

					window.dataLayer = window.dataLayer || [];
					window.dataLayer.push(
						Object.assign(
							{
								event: eventName
							},
							eventPayload
						)
					);

					if (
						window.Shopify
						&& window.Shopify.analytics
						&& typeof window.Shopify.analytics.publish === 'function'
					) {
						try {
							window.Shopify.analytics.publish(eventName, eventPayload);
						} catch (error) {
							/* no-op */
						}
					}
				}

				const clearCookieTriggers = () => {
					if ( this._cookieDelayTimer ) {
						window.clearTimeout(this._cookieDelayTimer);
						this._cookieDelayTimer = null;
					}
					if ( this._cookieScrollHandler ) {
						window.removeEventListener('scroll', this._cookieScrollHandler);
						this._cookieScrollHandler = null;
					}
				}

				const showBanner = (triggerSource = 'immediate') => {
					if ( this._cookieBannerShown ) return;
					this._cookieBannerShown = true;
					this._cookieBannerTrigger = triggerSource;
					clearCookieTriggers();
					this.o.enabled = true;
					this.show();
					publishCookieEvent('clarity_cookie_impression', {
						trigger_source: triggerSource
					});
				}
			
				const cookiesAccept = () => {
					window.Shopify.customerPrivacy.setTrackingConsent({
						"analytics": true,
						"marketing": true,
						"preferences": true
					}, () => {});
					localStorage.setItem('krown-cookie-banner', 'true'); 
					publishCookieEvent('clarity_cookie_accept', {
						trigger_source: this._cookieBannerTrigger
					});
				}
				const cookiesDecline = () => {
					window.Shopify.customerPrivacy.setTrackingConsent({
						"analytics": false,
						"marketing": false,
						"preferences": false
					}, () => {});
					localStorage.setItem('krown-cookie-banner', 'true'); 
					publishCookieEvent('clarity_cookie_decline', {
						trigger_source: this._cookieBannerTrigger
					});
				}
			
				const initCookieBanner = () => {
					if ( localStorage.getItem('krown-cookie-banner') === 'true' ) return;

					const config = window.__x4CookieTriggerConfig || { mode: 'immediate' };
					const mode = config.mode || 'immediate';

					if ( mode === 'delay_or_scroll' ) {
						const delayMs = Number(config.delayMs) || 3000;
						this._cookieDelayTimer = window.setTimeout(() => {
							showBanner('delay');
						}, delayMs);
						this._cookieScrollHandler = () => {
							showBanner('scroll');
						}
						window.addEventListener('scroll', this._cookieScrollHandler, { passive: true });
						return;
					}

					if ( mode === 'delay' ) {
						const delayMs = Number(config.delayMs) || 3000;
						this._cookieDelayTimer = window.setTimeout(() => {
							showBanner('delay');
						}, delayMs);
						return;
					}

					if ( mode === 'first_scroll' ) {
						this._cookieScrollHandler = () => {
							showBanner('scroll');
						}
						window.addEventListener('scroll', this._cookieScrollHandler, { passive: true });
						return;
					}

					showBanner('immediate');
				}

				const cookieAcceptElm = this.querySelector('[data-js-cookies-accept]');
				const cookieDeclineElm = this.querySelector('[data-js-cookies-decline]');

				if ( cookieAcceptElm ) {
					cookieAcceptElm.addEventListener('click', cookiesAccept);
				}
				if ( cookieDeclineElm ) {
					cookieDeclineElm.addEventListener('click', cookiesDecline);
				}

				window.Shopify.loadFeatures(
					[
						{
							name: 'consent-tracking-api',
							version: '0.1',
						},
					],
					error => {
						if (error) {
							throw error;
						}
						initCookieBanner();
					}
				);
			}

			if ( this.o.enabled ) {
			
				this._modalKey = `modal-${document.location.hostname}-${this.id}`;
				this._modalStorage = ! localStorage.getItem(this._modalKey) ? 'empty' : JSON.parse(localStorage.getItem(this._modalKey));
				if ( this.querySelector('[data-content]') ) {
					this._modalText = this.querySelector('[data-content]').textContent;
				}

				const timeNow = new Date().getTime();
				const inBetween = Math.round((timeNow - this._modalStorage['shown']) / 1000);

				let showModal = false;

				if ( this._modalStorage == 'empty'
					|| ( this.o.frequency == 'day' && inBetween > 86400 )
					|| ( this.o.frequency == 'week' && inBetween > 604800 )
					|| ( this.o.frequency == 'month' && inBetween > 2419200 )
					|| this._modalStorage['content'] != this._modalText
				) {
					showModal = true
				}

				if ( showModal ) {
					setTimeout(()=>{
						this.show();
					}, parseInt(this.o.show*1000));
					setTimeout(()=>{
						this.querySelectorAll('[data-js-close]').forEach(elm=>elm.addEventListener('click',()=>{this.hide(this.o.showOnce)}));
					}, 100);
				}

			} else if ( this.o.enabled == false ) {
				this.querySelectorAll('[data-js-close]').forEach(elm=>elm.addEventListener('click',()=>{this.hide(this.o.showOnce)}));
			}
			
			if ( this.o.enableClose == true ) {
				this.querySelectorAll('[data-js-close]').forEach(elm=>elm.addEventListener('click',()=>{this.hide(this.o.showOnce)}));
			}

			if ( this.o.closeByKey ) {
				document.addEventListener('keydown', e=>{
					if ( e.keyCode == 27 ) {
						if ( this.classList.contains('active') ) {
							this.hide(this.o.showOnce);
						}
					}
				});
			}

		}

		show(){
			this.setAttribute('style', '');
			setTimeout(()=>{
				this.classList.add('active');
				if ( this.o.disableScroll ) {
					document.body.classList.add(this.o.openedModalBodyClass);
				}
				if ( this.o.blockTabNavigation ) {
					(window.inertElems || document.querySelectorAll('[data-js-inert]')).forEach(elm=>{
						elm.setAttribute('inert', '');
					});
				}
			}, 10);
			setTimeout(()=>{
				if ( this.querySelector('[data-js-first-focus]') ) {
					this.querySelector('[data-js-first-focus]').focus();
				}
			}, 250);
		}

		hide(remember=false){
			this.classList.remove('active');
			document.body.classList.remove(this.o.openedModalBodyClass);
			setTimeout(()=>{
				this.style.display = 'none';
			}, 500);
			if ( remember && ! Shopify.designMode ){
				localStorage.setItem(this._modalKey, JSON.stringify({
					'shown': (new Date().getTime()),
					'content': this._modalText
				}));
			}
			(window.inertElems || document.querySelectorAll('[data-js-inert]')).forEach(elm=>{
				elm.removeAttribute('inert');
			});
		}

	}

  if ( typeof customElements.get('modal-box') == 'undefined' ) {

		// Clone modal elements and move to end of body IF append-top-body
		
		const originalElements = document.querySelectorAll('modal-box');

		originalElements.forEach((originalElement) => {
			const dataOptions = JSON.parse(originalElement.dataset.options);
			if ( dataOptions.appendToBody === true ) {
				document.body.appendChild(originalElement);
			}
		});

		customElements.define('modal-box', ModalBox);

	}

	// Shopify events

	document.addEventListener('shopify:section:select', (e)=>{
		if ( e.target.classList.contains('mount-popup') ) {
			e.target.querySelector('modal-box').style.display = 'block';
			e.target.querySelector('modal-box').show();
		}
	});
	document.addEventListener('shopify:block:select', (e)=>{
		if ( e.target.hasAttribute('data-modal-box') ) {
			e.target.style.display = 'block';
			e.target.show();
		}
	});
	document.addEventListener('shopify:block:deselect', (e)=>{
		if ( e.target.hasAttribute('data-modal-box') ) {
			e.target.hide();
		}
	});
	document.addEventListener('shopify:section:deselect', (e)=>{
		if ( e.target.classList.contains('mount-popup') ) {
			e.target.querySelector('modal-box').hide();
		}
	});

}
